import React from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import Header from "../Header";
import { makeStyles } from "@material-ui/core/styles";
import { Container } from "../shared/MaterialUI";

const ProtectedRoute = (props) => {
  const Component = props.component;
  const authToken = props.user.accessToken;  
  const classes = useStyles();  
  return authToken ? (
    <div className={classes.root}>
      <Header title={props.name} />
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Component />
        </Container>
      </main>
    </div>
  ) : (
    <Redirect to={{ pathname: "/login" }} />
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
    backgroundColor: '#E8E8E8',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));

export default connect(mapStateToProps)(ProtectedRoute);
